import React, {
  FC,
  PropsWithChildren,
  TransitionEvent,
  useEffect,
  useState,
} from "react";

export type PaginatedAreaProps = PropsWithChildren<{
  resetKey?: string;
  enableAnimation?: boolean;
  timePerPage?: number;
  onHidden?: () => void;
}>;

export const PaginatedArea: FC<PaginatedAreaProps> = ({
  enableAnimation = true,
  resetKey,
  onHidden,
  timePerPage = 20000,
  children,
}) => {
  const [showContent, setShowContent] = useState(true);

  useEffect(() => {
    if (!enableAnimation) {
      return;
    }

    const interval = setInterval(() => {
      setShowContent(false);
    }, timePerPage);

    return () => clearInterval(interval);
  }, [enableAnimation, resetKey, timePerPage]);

  const handleContentAnimationEnd = (e: TransitionEvent<HTMLElement>) => {
    if (e.propertyName === "opacity" && !showContent) {
      onHidden?.();
      setShowContent(true);
    }
  };

  return (
    <main data-show={showContent} onTransitionEnd={handleContentAnimationEnd}>
      {children}
    </main>
  );
};
